import React from "react";
import { LogoMark } from "@/components/Logo";
import { Waves } from "lucide-react";

/**
 * BrandStrip — sits directly under the fixed Header on the home page.
 * Introduces the pelican mascot at a larger size with a catchy tagline
 * before the sunset hero. Deliberately uses the same off-white sand tone
 * from the editorial palette so it bridges header → hero.
 */
const BrandStrip = () => (
  <section
    id="brand-strip"
    data-testid="brand-strip"
    className="relative isolate overflow-hidden"
    style={{ backgroundColor: "#FFFFFF" }}
  >
    {/* very soft warm sunburst top-right, matching the hero palette */}
    <div
      className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full opacity-50 blur-3xl"
      aria-hidden="true"
      style={{
        background:
          "radial-gradient(circle, rgba(255,183,105,0.45) 0%, rgba(255,183,105,0) 70%)",
      }}
    />

    <div className="relative mx-auto flex max-w-7xl flex-col items-center gap-8 px-6 py-16 text-center md:flex-row md:gap-14 md:px-12 md:py-20 md:text-left">
      {/* Pelican mascot — large */}
      <div className="shrink-0" data-testid="brand-strip-logo">
        <LogoMark
          size={168}
          className="drop-shadow-[0_10px_30px_rgba(11,61,78,0.15)]"
        />
      </div>

      {/* Copy */}
      <div className="flex-1">
        <div className="mb-4 flex items-center justify-center gap-3 md:justify-start">
          <Waves size={16} strokeWidth={2.2} style={{ color: "#2F7E88" }} />
          <p
            className="font-body text-[11px] font-semibold uppercase tracking-[0.32em]"
            style={{ color: "#0B3D4E" }}
          >
            Wilmington, NC · The Cape Fear Region
          </p>
        </div>
        <h2
          data-testid="brand-strip-heading"
          className="font-heading text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
          style={{ color: "#0B3D4E" }}
        >
          Where the pelican lands,
          <br className="hidden md:inline" />{" "}
          <span
            className="italic"
            style={{
              color: "#2F7E88",
              fontFamily: "Georgia, 'Times New Roman', serif",
            }}
          >
            the restrooms sparkle.
          </span>
        </h2>
        <p
          data-testid="brand-strip-subtitle"
          className="mx-auto mt-5 max-w-2xl font-body text-base font-medium leading-relaxed md:mx-0 md:text-lg"
          style={{ color: "rgba(11, 61, 78, 0.78)" }}
        >
          Deep Clean is Wilmington's commercial restroom specialist — one
          focus, one craft. Locally owned, coast-obsessed, restroom-focused.
        </p>
      </div>
    </div>

    {/* thin divider line into the hero */}
    <div
      className="pointer-events-none absolute inset-x-0 bottom-0 h-px"
      style={{ backgroundColor: "#0B3D4E", opacity: 0.1 }}
      aria-hidden="true"
    />
  </section>
);

export default BrandStrip;
